import { GetCustomerByProjectId, GetCustomerByProjectIdToken } from "$src/application/projects/queries/GetCustomerByProjectId";
import { Customer } from "$src/domain/customers/Customer";
import { useQuery } from "@sveltestack/svelte-query";
import { container } from "tsyringe";

interface FetchProjectCustomerParams {
    queryKey: ['project-customer', number, number];
}

export async function fetchProjectCustomer( { queryKey } : FetchProjectCustomerParams): Promise<Customer> {
    const [_, groupStoreId, projectId] = queryKey;
    const query = container.resolve<GetCustomerByProjectId>(GetCustomerByProjectIdToken);
    return query.execute(groupStoreId, projectId);
}

export function useProjectCustomer(groupStoreId: number, projectId: number) {

    return useQuery<Customer, Error, Customer, ['project-customer', number, number]>(
        ['project-customer', groupStoreId, projectId], 
        fetchProjectCustomer,
        {
            staleTime: 30000,
            cacheTime: 60000,
        }
    );
}